import { useMergeGuestSession } from 'features/guest-session'

/**
 * Offers the demo-results claim after any sign-in (FE-310). Lives at the app
 * root so it runs on every page, not only where the header is mounted.
 */
export const GuestMergeEffect = () => {
  useMergeGuestSession()
  return null
}
